export const TEST_ID = 'entityMenu';

export const MENU_DIRECTION = 'bottomRight';
